import { render } from "./FormState.vue?vue&type=template&id=bb117fac"
import script from "./FormState.vue?vue&type=script&lang=ts"
export * from "./FormState.vue?vue&type=script&lang=ts"
script.render = render

export default script